export const TOKEN_REFRESH_INTERVAL_SECONDS = 60;
export const TOKEN_EXPIRATION_WINDOW_SECONDS = 60;
export const TOKEN_REFRESH_JITTER_MIN = 1;
export const TOKEN_REFRESH_JITTER_MAX = 1.2;
export const STORAGE_SYNC_CHANNEL = 'auth-storage-sync';
export const REFRESH_LOCK_NAME = 'auth-token-refresh';
